import axios from "axios";

import { COMMERCIAL_FINANCIAL_API_URL } from "../../config/apiConfig";
import { currentSession } from "../../utils/session";

/**
 * Catalogue commercial ASSIGANTO, source unique des offres et des prix.
 *
 *   Navigateur :3000 → Gateway :8080 → assiganto-commercial-financial-platform :1999
 *   GET /countries                                  public
 *   GET /catalog/offers?profile=PRODUCTEUR&country= public (le pays du JWT prime s'il est connecté)
 *
 * Le frontend ne connaît ni prix, ni taux de change, ni composition d'offre : il affiche
 * ce que renvoie le backend.
 */
const api = axios.create({
    baseURL: COMMERCIAL_FINANCIAL_API_URL,
    timeout: 20000
});

/** Le jeton (s'il est valide) permet au backend d'appliquer le pays du compte. */
const sessionHeaders = () => {
    const session = currentSession();
    return session ? { Authorization: `Bearer ${session.token}` } : {};
};

const isRejectedToken = (error) =>
    error?.response?.status === 401 && error?.response?.data?.error === "INVALID_TOKEN";

/**
 * Le backend refuse tout jeton invalide (401 INVALID_TOKEN), même sur le catalogue public :
 * un jeton de session périmé ou révoqué ne doit pas priver le visiteur des tarifs, le
 * catalogue est alors relu sans jeton (pays de la requête).
 *
 * @param {{profile?: "PRODUCTEUR"|"SPECULATEUR"|"EXPORTATEUR", country?: string}} query
 */
export const getCatalogOffers = async ({ profile, country }) => {
    const params = { profile, country: country || undefined };
    const headers = sessionHeaders();
    try {
        const { data } = await api.get("/catalog/offers", { params, headers });
        return data;
    } catch (error) {
        if (!headers.Authorization || !isRejectedToken(error)) throw error;
        const { data } = await api.get("/catalog/offers", { params });
        return data;
    }
};

export const getCountries = async () => {
    const { data } = await api.get("/countries");
    return data.countries || [];
};

const commercialCatalogService = { getCatalogOffers, getCountries };

export default commercialCatalogService;
